import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useScrollToAnchor() {
  const location = useLocation();
  
  useEffect(() => {
    // Check if the URL has a hash
    if (location.hash) {
      // Remove the # character
      const elementId = location.hash.substring(1);
      
      // Wait for DOM to be fully loaded/updated
      setTimeout(() => {
        const element = document.getElementById(elementId);
        if (element) {
          // Adjust scroll position to account for fixed header height
          const headerHeight = 90; // Adjust based on your header height
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerHeight;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        } else {
          console.warn(`Element with id "${elementId}" not found`);
        }
      }, 300); // Increased timeout to ensure DOM is ready
    } else {
      // If no hash, scroll to top when navigating to a new page
      window.scrollTo(0, 0);
    }
  }, [location]); // Re-run when location changes
}